import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-199b85d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frontpage" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Hakosalo Akatemia - Elinvoimaa alueellesi", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "helpdesk-box" }, [
    /*#__PURE__*/_createElementVNode("b", null, " Hakosalo Helpdesk "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:helpdesk@hakosalo.fi" }, "helpdesk@hakosalo.fi"),
    /*#__PURE__*/_createElementVNode("a", { href: "tel:010 231 0560" }, "010 231 0560")
  ])
], -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-8" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-4 mb-2 mt-2" }
const _hoisted_10 = { class: "col-md-4 mb-2 mt-2" }
const _hoisted_11 = { class: "col-md-4 mb-2 mt-2" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-4 mb-2 mt-4" }
const _hoisted_14 = { class: "col-md-4 mb-2 mt-4" }
const _hoisted_15 = { class: "col-md-4 mb-2 mt-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-4 mb-2 mt-4" }
const _hoisted_18 = { class: "col-md-4 mb-2 mt-4" }
const _hoisted_19 = { class: "col-md-4 mb-2 mt-4" }
const _hoisted_20 = { class: "col-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_guide_search = _resolveComponent("guide-search")!
  const _component_LatestNews = _resolveComponent("LatestNews")!
  const _component_HakoContentBlock = _resolveComponent("HakoContentBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_guide_search),
        _hoisted_4
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.attemptToNavigate('crm_kategoria')), ["prevent"])),
              class: "banner-link",
              src: "/CRM_ja_yrityspalvelut.jpg"
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.attemptToNavigate('yp-hakemisto_kategoria')), ["prevent"])),
              class: "banner-link",
              src: "/YP-hakemisto.jpg"
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.attemptToNavigate('perustamisneuvonta_kategoria')), ["prevent"])),
              class: "banner-link",
              src: "/Perustamisneuvonta.jpg"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.attemptToNavigate('hankkeet_kategoria')), ["prevent"])),
              class: "banner-link",
              src: "/Hankkeet.jpg"
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.attemptToNavigate('kotoutuminen_kategoria')), ["prevent"])),
              class: "banner-link",
              src: "/Kotoutuminen.jpg"
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.attemptToNavigate('tyollisyyspalvelut_kategoria')), ["prevent"])),
              class: "banner-link",
              src: "/Tyollisyyspalvelut.jpg"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("img", {
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.attemptToNavigate('hakemukset_kategoria')), ["prevent"])),
              class: "banner-link",
              src: "/Hakemukset.jpg"
            })
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("img", {
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.attemptToNavigate('kumppanit_kategoria')), ["prevent"])),
              class: "banner-link",
              src: "/Kumppanit.jpg"
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("img", {
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.attemptToNavigate('toimitilat_kategoria')), ["prevent"])),
              class: "banner-link",
              src: "/Toimitilat.jpg"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", null, [
          _createVNode(_component_HakoContentBlock, {
            "no-border": "",
            "no-padding": "",
            theme: "topical",
            class: "mt-2",
            label: 'Ajankohtaista',
            collapsable: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LatestNews)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}